import api from 'plugin/api';
import { API_URL } from 'types/const';
import format from 'utils/string/format';

/**
 * 사용자 수정
 * @param {number} seq 사용자 번호
 * @param {Object} data 요청 데이터
 * @param {string} data.email 이메일
 * @param {string} [data.userPwd] 패스워드
 * @param {number} data.factoryCodeSeq 기본 조회
 * @return {Object} 응답 데이터
 */
async function requestUpdate(seq, data) {
  return api.put(format(API_URL.user.inform, { seq }), data);
}

/**
 * 사용자 정보 조회
 * @param {number} seq 사용자 번호
 * @return {Object} 응답 데이터
 */
async function requestInform(seq) {
  return api.get(format(API_URL.user.inform, { seq }));
}

/**
 * 비밀번호 찾기
 * @param {Object} params 요청 데이터
 * @param {string} params.userId 아이디
 * @param {string} params.email 이메일
 * @return {Object} 응답 데이터
 */
async function requestFindPassword(params) {
  return api.get(API_URL.user.findPassword, { params });
}

/**
 * 패스워드 재확인
 * @param {Object} data 요청 데이터
 * @param {string} data.userPwd 패스워드
 * @return {Object} 응답 데이터
 */
async function requestValid(data) {
  return api.post(API_URL.user.valid, data);
}

export { requestUpdate, requestInform, requestFindPassword, requestValid };
